import Vue from 'vue';
import { computed } from '@vue/composition-api';
import PageHeader from '@/components/common/PageHeader.vue';
export default Vue.extend({
    name: 'NotFoundPage',
    components: {
        PageHeader
    },
    setup(props, context) {
        const content = computed(() => context.root.$store.state.Content.content);
        return {
            content
        };
    }
});
